import { render, staticRenderFns } from "./quotes-block-knowledge.vue?vue&type=template&id=9960e554&scoped=true"
var script = {}
import style0 from "./quotes-block-knowledge.vue?vue&type=style&index=0&id=9960e554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9960e554",
  null
  
)

export default component.exports